import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'T&M Construction', 
  description = 'Professional construction, renovation and maintenance services across Suffolk, Essex, and London. Quality workmanship with over a decade of experience.',
  keywords = 'construction, builders, renovation, Ipswich, Suffolk, Essex, London, T&M Construction, home improvement, painting, decorating',
  canonical,
  type = 'website',
  image = 'https://tandmbuilders.co.uk/og-image.jpg'
}) => {
  const siteUrl = 'https://tandmbuilders.co.uk';
  const fullTitle = title === 'T&M Construction' ? title : `${title} | T&M Construction`;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="T&M Construction" />
      
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={`${siteUrl}${canonical}`} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={canonical ? `${siteUrl}${canonical}` : siteUrl} />
      <meta property="og:site_name" content="T&M Construction" />
      <meta property="og:locale" content="en_GB" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="geo.region" content="GB-SFK" />
      <meta name="geo.placename" content="Ipswich" />
    </Helmet>
  );
};

export default SEO;
